import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import useTopicsList from "~/features/SearchV3/hooks/useTopicsList";
import TopicItem from "./TopicItem";

const TopicItemList = () => {
    const { filteredTopics, handleTopicBtnClick } = useTopicsList();
    const { t } = useTranslation();

    // Filter topics with count > 0
    const validTopics = useMemo(() => {
        return filteredTopics?.filter(topic => topic.count > 0) || [];
    }, [filteredTopics]);

    const topicList = useMemo(() => {
        return validTopics.map((item, id) => (
            <TopicItem
                key={id}
                topic={item}
                btnClickCallback={handleTopicBtnClick}
            />
        ));
    }, [validTopics, handleTopicBtnClick]);

    if (validTopics.length === 0) {
        return null;
    }

    return (
        <div className="flex flex-col gap-1">
            <div className="flex items-center justify-between py-3 px-4 gap-2 text-sm text-stone-vibrant font-medium-light tracking-[-0.28px]">
                <div>{t("searchForm.popup.topicLabel")}</div>
                <div>{t("searchForm.popup.countResultsLabel")}</div>
            </div>
            {topicList}
        </div>
    );
};

export default TopicItemList;
